import { defineOperationManifest } from "../define"

export const menuTranslateManifest = defineOperationManifest({
	type: "menu.translate",
	ability: "restaurant.menu::create",
	bocLabelKey: "operations.boc.types.menuTranslate",
})
